const advantagesWorkItems = document.querySelectorAll('.js-advantages-work__item.hide-mob');
const advantagesWorkMoreBtn = document.querySelector('.js-advantages-work__more-btn');

if (advantagesWorkItems.length && advantagesWorkMoreBtn) {
	advantagesWorkMoreBtn.addEventListener('click', () => {
		Array.from(advantagesWorkItems).forEach((item) => {
			item.classList.remove('hide-mob');
		});

		advantagesWorkMoreBtn.classList.add('hide-mob');
	});
}
